import { createRouter, createWebHistory } from 'vue-router'
import { ModuleContext } from '@/stores/moduleConst'
import store from '@/stores/store'
import commonFn from '@/commons/commonFunction'
import popupUtil from '@/commons/popupUtil'
import routerPage, { AUTHORIZE_ROUTE_NAME } from './routerPage'
import routerDemo from './routerDemo'
import i18n from '@/i18ns/i18n'
export const MAIN_LAYOUT_ROUTER_NAME = 'MainLayout'

const routes = [
  {
    path: '/',
    name: MAIN_LAYOUT_ROUTER_NAME,
    component: () => import('@/layouts/MainLayout.vue'),
    redirect: {
      name: 'GeneralPortal',
    },
    children: [
      ...routerDemo,
      {
        path: '/',
        name: 'GeneralPortal',
        component: () =>
          import(
            /* webpackChunkName:'generalPortal' */ '@/pages/home/Index.vue'
          ),
      },
      {
        path: '/:parentCode',
        name: 'SGDPortal',
        component: () =>
          import(
            /* webpackChunkName:'sgdPortal' */ '@/pages/sgdPortal/Index.vue'
          ),
        children: [
          {
            path: '',
            name: 'SGDPortalView',
            component: () =>
              import(
                /* webpackChunkName:'sgdPortalView' */ '@/pages/home/Index.vue'
              ),
          },
          {
            path: 'profile',
            name: 'SGDProfile',
            component: () =>
              import(
                /* webpackChunkName:'sgdProfile' */ '@/pages/profile/Index.vue'
              ),
            children: [
              {
                path: 'account-infor',
                name: 'SGDAccountInfor',
                component: () =>
                  import(/* webpackChunkName:'sgdAccountInfor' */ '@/pages/profile/accountInfor/Index.vue'),
              },
              {
                path: 'my-profile',
                name: 'SGDMyProfile',
                component: () =>
                  import(/* webpackChunkName:'sgdMyProfile' */ '@/pages/profile/myProfile/Index.vue'),
              },
            ],
          },
          {
            path: 'admission-detail',
            name: 'SGDAdmission',
            component: () =>
              import(
                /* webpackChunkName:'SGDAdmission' */ '@/pages/admission/detail/Index.vue'
              ),
            meta: {
              title: 'DetailAdmission',
              excludeFooter: true,
            },
          },
        ],
      },
      {
        path: '/:parentCode/:tenantCode',
        name: 'Detail',
        component: () =>
          import(
            /* webpackChunkName:'detail' */ '@/pages/detail/Index.vue'
          ),
        children: [
          {
            path: '',
            name: 'TenantDetail',
            component: () =>
              import(
                /* webpackChunkName:'tenantDetail' */ '@/views/detail/Index.vue'
              ),
          },
          {
            path: ':postId',
            name: 'PostDetail',
            component: () =>
              import(
                /* webpackChunkName:'postDetail' */ '@/pages/post/Index.vue'
              ),
          },
          {
            path: 'create',
            name: 'CreateAdmission',
            component: () =>
              import(
                /* webpackChunkName:'createAdmission' */ '@/pages/admission/create/Index.vue'
              ),
            meta: {
              title: 'CreateAdmission',
              excludeFooter: true,
            },
          },
          {
            path: 'preview',
            name: 'PreviewAdmission',
            component: () =>
              import(
                /* webpackChunkName:'createAdmission' */ '@/pages/admission/preview/Index.vue'
              ),
            meta: {
              title: 'PreviewAdmission',
              excludeFooter: true,
            },
          },
          {
            path: 'profile',
            name: 'DetailProfile',
            component: () =>
              import(
                /* webpackChunkName:'detailProfile' */ '@/pages/profile/Index.vue'
              ),
            children: [
              {
                path: 'account-infor',
                name: 'DetailAccountInfor',
                component: () =>
                  import(/* webpackChunkName:'detailAccountInfor' */ '@/pages/profile/accountInfor/Index.vue'),
              },
              {
                path: 'my-profile',
                name: 'DetailMyProfile',
                component: () =>
                  import(/* webpackChunkName:'detailMyProfile' */ '@/pages/profile/myProfile/Index.vue'),
              },
            ],
          },
          {
            path: 'admission-detail',
            name: 'DetailAdmission',
            component: () =>
              import(
                /* webpackChunkName:'detailAdmission' */ '@/pages/admission/detail/Index.vue'
              ),
            meta: {
              title: 'DetailAdmission',
              excludeFooter: true,
            },
          },
        ],
      },
      {
        path: '/profile',
        name: 'Profile',
        component: () =>
          import(
            /* webpackChunkName:'Profile' */ '@/pages/profile/Index.vue'
          ),
        children: [
          {
            path: 'account-infor',
            name: 'AccountInfor',
            component: () =>
              import(/* webpackChunkName:'AccountInfor' */ '@/pages/profile/accountInfor/Index.vue'),
          },
          {
            path: 'my-profile',
            name: 'MyProfile',
            component: () =>
              import(/* webpackChunkName:'MyProfile' */ '@/pages/profile/myProfile/Index.vue'),
          },
        ],
      },
      {
        path: 'admission-detail',
        name: 'GeneralDetailAdmission',
        component: () =>
          import(
            /* webpackChunkName:'generalDetailAdmission' */ '@/pages/admission/detail/Index.vue'
          ),
        meta: {
          title: 'DetailAdmission',
          excludeFooter: true,
        },
      },
    ],
  },
  ...routerPage,
  {
    // Redirect to 404 page, if no match found
    path: '/:pathMatch(.*)*',
    component: () => import(/* webpackChunkName:'pages' */ '@/pages/404.vue'),
    meta: {
      anonymous: true,
    },
  },
]

const baseUrl = window.__env.base_router

const router = createRouter({
  history: createWebHistory(baseUrl),
  routes,
})

router.afterEach(() => {
  commonFn.unmask()
})

/**
   * Kiểm tra xem còn session đăng nhập ko
   */
const isAuthenticated = () => {
  const context = store.state[ModuleContext]
  if (context.Token) {
    const expired = context.TokenExpired
    return expired && expired > new Date()
  }
  return true
}

router.beforeEach((to, from, next) => {
  // khi chuyển router sẽ show maskloading cho người dùng biết xử lý
  // do tình huông tải file js chậm
  // trong after sẽ ẩn mask loading đi
  // Tạm thời dùng loading global, sau này có thể làm kiểu thanh line chạy ngay dưới address bar sau
  commonFn.mask()

  // hide all popup
  // TODO => Ẩn tất cả popup ở đây
  popupUtil.hideAll()

  // // trang không authen
  if (to.meta.anonymous) {
    next()
    return
  }

  // // kiểm tra authen -> fail redirect login
  if (!isAuthenticated()) {
    next({
      name: AUTHORIZE_ROUTE_NAME,
      query: {
        callbackUrl: encodeURI(to.fullPath),
      },
    })

    return
  }

  // default
  next()
})

const isNullOrUndefined = (val) => val === null || val === undefined

/**
 * @author PVThang
 * @description Set title cho page trên thanh Top Nav
 * @param {*} to
 */
const setTitle = (to) => {
  const titleName = to.matched.findLast(
    (route) => !isNullOrUndefined(route.meta?.title)
  )?.meta.title
  const title = titleName ? i18n.global.t(`i18nMain.Title.${titleName}`) : null

  store.commit('setTitle', title)
}

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from, failure) => {
  setTitle(to)
})

export default router
